import React from 'react';
import PropTypes from 'prop-types';

import { CONTENT_PROPS, IMAGE_CROP_MODES, ITEM_LABEL_PROPS, TEXT_MODES } from '../shared/constants';
import {
  getContentImageByMode,
  getUrlUnityImageApi,
} from '../../utils/imageUtils';
import Skeleton from './components/Skeleton';
import SchedulePopover from '../BannerHero/components/SchedulePopover';
//#region //// DUCKS ////
import './styles.scss';
import { IMAGE_MODE } from '../../constants/imageMode';
import * as utils from './utils';
import ImgComponent, { LOADING_IMG } from '../../HOCs/ImageHocs';
import classNames from '../../utils/classnameUtils';
import { isContentLive, isContentFuture } from '../../utils/contentOverviewUtils';
import TrailerOverview from './components/TrailerOverview';
import { Button, ProgressBar } from 'react-bootstrap';
import { CONTENT_TYPES } from '../../constants/contentTypes';
//#endregion

const itemStyles = {
  LIVE: 'live_now',
};

function ContentCard({
  translationTexts,
  content,
  imageMode,
  prefixNetworkText = '',
  trailerOverview = false,
  textMode,
  itemLabel,
  itemStyle,
  playAndFavorite = false,
  isLoading = false,
  contentNoImageProps,
  networks,
  channels,
  selectedContentHandler,
  onClickPlayerButton,
  onClickMyListButton,
  onClickSelectedContentButton,
  favorites,
  authenticated,
  accessToken = null,
  className,
  loading = LOADING_IMG.LAZY,
  lang = 'en'
}) {
  const [imageBoolCard, setImageBoolCard] = React.useState(false);
  const [imageBoolNetwork, setImageBoolNetwork] = React.useState(true);
  const [enableTrailerComponent, setEnableTrailerComponent] =
    React.useState(false);
  //const [trailerUrlState, setTrailerUrlState] = React.useState(null);
  const [myListBool, setMyListBool] = React.useState(false);
  const TRAILER_REF = React.useRef(null);

  //const { end, start } = content?.flights[0]?.flights[0];
  const contentFlights = content?.flights ?? [];
  const startDateContent = contentFlights[0]?.flights[0]?.start;
  const endDateContent = contentFlights[0]?.flights[0]?.end;
  const isFutureContent = isContentFuture(startDateContent) && !isContentLive(startDateContent, endDateContent);

  const { channel, srcChannelOrNetwork } = utils.channelOrNetwork(
    content,
    channels,
    networks
  );

  React.useEffect(() => {
    if (Array.isArray(favorites)) {
      setMyListBool(favorites.some((e) => e === content.id));
    }
  }, [favorites]);

  if (isLoading)
    return (
      <Skeleton
        textMode={textMode}
        imageMode={imageMode}
        {...contentNoImageProps}
        classNameProps={classNames(className, 'tbxContentCard__skeleton')}
      />
    );

  const imageData =
    content.serieProps && content.contentType === CONTENT_TYPES.EPISODE
      ? getContentImageByMode(content.serieProps.images, imageMode)
      : getContentImageByMode(content.images, imageMode);
  const imageSrc = imageData && imageData.url;

  const aspectRatio = contentNoImageProps?.width / contentNoImageProps?.height;

  const srcTemporal = content?.embeddedTrailer?.url && false;

  const handleEnterMouseOver = () => {
    /*if(content?.trailerConfig?.isTrailer && content?.trailerConfig?.trailerOfId && !trailerUrlState && accessToken){
      utils.getContentsUrlById(accessToken,content.trailerConfig.trailerOfId,setTrailerUrlState)
    }*/
    /*if (srcTemporal) {
      setTrailerUrlState(srcTemporal)
    }*/
    setEnableTrailerComponent(true);
  };

  const handleOnMouseLeave = () => {
    setEnableTrailerComponent(false);
  };

  const handlePlayerFromTrailer = (event) => {
    event.stopPropagation();
    onClickPlayerButton(content);
  };

  const handleMyListrFromTrailer = (event) => {
    event.stopPropagation();
    onClickMyListButton(content.id);
  };

  const innerBool =
    (textMode === TEXT_MODES.INNER &&
      !!content.title) ||
    playAndFavorite ||
    typeof content?.bookmark?.position === 'number';

  return (
    <div
      className={classNames(
        `tbxContentCard`,
        `__imageMode-${imageMode.toLowerCase()}`,
        `__textMode-${textMode.toLowerCase()}`,
        `__imageBool-${imageBoolCard}`,
        `__dataInner-${innerBool}`,
        className
      )}
      onMouseEnter={handleEnterMouseOver}
      onMouseLeave={handleOnMouseLeave}
    >
      <figure
        className={classNames(
          'tbxContentCard__content-image',
          'tbxContentCard__aspect-ratio',
          content.contentType === CONTENT_TYPES.BROADCAST &&
            `rollover rollover-${utils.formatChannelClassName(content.title)}`
        )}
        style={{
          position: 'relative',
          '--aspect-ratio': !!aspectRatio ? aspectRatio : 0,
          overflow: 'hidden',
          margin: '0px',
          height: 'auto',
          transform: trailerOverview ? 'scale(1)' : '',
        }}
        onClick={selectedContentHandler}
      >
        {/* IMG */}
        {
          <ImgComponent
            {...{
              className: 'tbxContentCard__image',
              alt: `img-content-${content.id || content.externalId}`,
              src: getUrlUnityImageApi(imageSrc),
              crop: IMAGE_CROP_MODES.resizeScaleAndCrop,
              size: imageMode,
              loading: loading,
              width: '100%',
              height: '100%',
              setimagebool: (e) => setImageBoolCard(e),
            }}
          />
        }

        {/* LIVE BADGE */}
        {((content.contentType !== CONTENT_TYPES.SPORT && !!content.live) ||
          (content.contentType === CONTENT_TYPES.SPORT &&
            isContentLive(startDateContent, endDateContent)) || itemStyle === itemStyles.LIVE) && (
            <div className='tbxContentCard__badge-container'>
              <div className='tbxContentCard__data-inner_badge-live'>
                {translationTexts.live}
              </div>
            </div>
          )}

        {innerBool && (
          <div className='tbxContentCard__data-inner'>
            {/* TITULO */}
            {textMode === TEXT_MODES.INNER &&
              !!content.title && (
              <div className='tbxContentCard__data-inner_title'>
                {content.title}
              </div>
            )}
            
            {/* PLAY Y FAVORITE */}
            {playAndFavorite && (
              <div className='tbxContentCard__data-inner_playAndFavorite'>
                {!content.live && (<Button
                  className='tbxContentCard__data-inner_playAndFavorite_play_button'
                  onClick={(event) => handlePlayerFromTrailer(event)}
                >
                  <i className='bi bi-play-circle' />
                </Button>)}
                {authenticated && !content.live && (
                  <Button
                    className='tbxContentCard__data-inner_playAndFavorite_favorite_button'
                    onClick={(event) => handleMyListrFromTrailer(event)}
                  >
                    {myListBool ? (
                      <i className='bi bi-check-circle' />
                    ) : (
                      <i className='bi bi-plus-circle' />
                    )}
                  </Button>
                )}
              </div>
            )}
            {/* BOOKMARK */}
            {typeof content?.bookmark?.position === 'number' && (
              <ProgressBar
                className='tbxContentCard__data-inner_progressBar'
                now={content.bookmark.position}
                max={content.duration}
              />
            )}
          </div>
        )}
        {/* NETWORK */}
        {imageBoolNetwork && (
          <div
            className={classNames(
              'tbxContentCard__network-content',
              '__imgType-' + (!!channel ? 'channel' : 'network')
            )}
          >
            <ImgComponent
              className='tbxContentCard__network-img'
              src={getUrlUnityImageApi(srcChannelOrNetwork)}
              size={IMAGE_MODE.NETWORK}
              setimagebool={(e) => setImageBoolNetwork(e)}
              loading={loading}
            />
          </div>
        )}
        {content.live &&
          !isContentLive(startDateContent, endDateContent) &&
          content.contentType === CONTENT_TYPES.SPORT &&
          !!endDateContent && (
            <div className='schedule__button'>
              <SchedulePopover
                content={content}
                schedule=''
                buttonType='icon'
              />
            </div>
          )}
      </figure>
      {/* OUTER */}
      {/* TITULO Y SUBTITULO */}
      {textMode === TEXT_MODES.OUTER && content.title && (
        <div className='tbxContentCard__data'>
          <h3 className='tbxContentCard__data-title'>{`${content.serieProps &&
            content.contentType === CONTENT_TYPES.EPISODE
            ? `${content.serie.title} - T${content.season}:E${content.episode} - ${content.title}`
            : content.title
            }`}</h3>
        </div>
      )}
      {/* NETWORKS */}
      {content.networks && (
        <div className='tbxContentCard__data'>
          {itemLabel === ITEM_LABEL_PROPS.time && isFutureContent && (
            <span className='tbxContentCard__data-time'>
              {utils.getFormatedDate({ date: startDateContent, lang, hoursString: translationTexts?.hr })}
            </span>
          )}
          {content.networks &&
            itemLabel === ITEM_LABEL_PROPS.network &&
            content.contentType !== CONTENT_TYPES.SPORT && (
              <p className='tbxContentCard__data-subtitle'>
                {`${prefixNetworkText}`}
                {content.networks.map((network) => network.name)}
              </p>
            )}
        </div>
      )}

      {trailerOverview && enableTrailerComponent && (
        <TrailerOverview
          videoSource={content?.embeddedTrailer?.url}
          content={content}
          TRAILER_REF={TRAILER_REF}
          prefixNetworkText={prefixNetworkText}
          onClickSelectedContentButton={onClickSelectedContentButton}
          handleMyListrFromTrailer={handleMyListrFromTrailer}
          handlePlayerFromTrailer={handlePlayerFromTrailer}
          favorites={favorites}
          authenticated={authenticated}
        />
      )}
    </div>
  );
}

ContentCard.propTypes = {
  content: PropTypes.shape(CONTENT_PROPS),
  imageMode: PropTypes.oneOf(Object.values(IMAGE_MODE)),
  prefixNetworkText: PropTypes.string,
  isLoading: PropTypes.bool,
  contentNoImageProps: PropTypes.object,
  textMode: PropTypes.string,
  networks: PropTypes.array,
  channels: PropTypes.array,
  selectedContentHandler: PropTypes.func,
  className: PropTypes.string,
  loading: PropTypes.oneOf(Object.values(LOADING_IMG)),
  itemLabel: PropTypes.string,
};

export default React.memo(ContentCard);
